import CloseIcon from "assets/icons/close";
import styles from "./SpectacleDetailStream.module.css";
import { pingStream } from "services/api";
import { useEffect } from "react";


const SpectacleDetailStream = ({ iframe, setVideoUrl, sessionId }) => {

  useEffect(() => {
    const id = setInterval(() => {
      pingStream({ sessionId })
        .then(response => {
          if (response.success) {
            // Gérer le succès (par exemple, mettre à jour l'état)
          } else {
            setVideoUrl(null);
          }
        });
    }, 30000);

    return () => clearInterval(id);
  }, []);

  return (
    <div className={styles.iframeContainer} dangerouslySetInnerHTML={{ __html: iframe }} />
  )
}


export default SpectacleDetailStream;





































